import React from 'react';

const TextField = ({
  label,
  placeholder,
  value,
  onChange,
  className,
  disabled = false,
  type = 'text',
  theme = 'light',
}) => (
  <div className={`w-full flex flex-col ${className}`}>
    {label && (
      <label className={`text-sm font-semibold mb-2 ml-1 ${theme === 'light' ? 'text-gray-700' : 'text-gray-300'}`}>
        {label}
      </label>
    )}
    <input
      className={`appearance-none block w-full border rounded-lg py-3 px-4 leading-tight focus:outline-none focus:ring-1 focus:ring-teal-500 transition-all duration-200 ${theme === 'light'
          ? 'bg-white text-gray-700 border-gray-300 focus:bg-white focus:border-teal-500'
          : 'bg-gray-800 text-gray-200 border-gray-700 focus:bg-gray-700 focus:border-teal-500'
        }`}
      type={type}
      disabled={disabled}
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
    />
  </div>
);

export default TextField;
